export default __webpack_public_path__ + "static/media/0.775d26af.png";